import { ActionMenu as CwActionMenu } from '@cw-ui/navigation-components';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';
import { DeleteButton } from './ActionMenu.styled';
import { useDispatch } from 'react-redux';
import { setRemoveUserDialogOpen } from '../../slice';

export function ActionMenu({ handleEditClick, rowId }) {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {
        dispatch(setRemoveUserDialogOpen(rowId));
    };

    const actions = [
        {
            id: 'edit',
            title: formatMessage(Locale.edit),
            onClick: () => {
                handleEditClick();
            },
        },
        {
            id: 'delete',
            renderValue: () => {
                return <DeleteButton>{formatMessage(Locale.delete)}</DeleteButton>;
            },
            onClick: () => {
                handleDeleteClick();
            },
        },
    ];

    return (
        <CwActionMenu
            actions={actions}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            horizontal="left"
            data-testid="actionmenu-overflow-menu"
            id="actionmenu-overflow-menu"
            transformOrigin={{
                horizontal: 'left',
            }}
        />
    );
}
